export function Skeleton({ className = "", style = {}, ...props }) {
  return <div className={`skeleton ${className}`} {...props} style={{ width: "100%", height: 12, ...style }} />;
}
